import { render } from "./draft_closer.vue?vue&type=template&id=434533bb"
import script from "./draft_closer.js?vue&type=script&lang=js"
export * from "./draft_closer.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__